import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { ChatStyle } from './Chat.style';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ChatStyle> {
  message:string;
}

class ChatInfoMessage extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {

    const {classes, message} = this.props;
    
    return (
      <div className={classes.chatMessage}>
        <div className={classes.chatMessageInfo}>
          {message}
        </div>
      </div>

    );  
  }

}


export default (withStyles(ChatStyle)(ChatInfoMessage));



// WEBPACK FOOTER //
// ./src/components/chat/ChatInfoMessage.tsx